import axios from 'axios';
// HOSTED
const baseurl = process.env.REACT_APP_BASE_URL;
const cancelTokenSource = axios.CancelToken.source();

let token = localStorage.getItem('token');

axios.interceptors.request.use(
  (config) => {
    config.cancelToken = cancelTokenSource.token;
    const token = JSON.parse(localStorage.getItem('token'));
    if (token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response.status === 401 ||
      error.response.status === 403 ||
      error.code === 'ERR_NETWORK' // axios not giving normal response status
    ) {
      cancelTokenSource.cancel('Request dibatalkan karena respons 401');
      const logoutButton = document.getElementById('logoutButton');
      if (logoutButton) {
        console.log('button logout');
        logoutButton.click(); // Pemicu klik tombol logout
      }
    }
    return Promise.reject(error);
  }
);

class ApiService {
  loginIdaman(tokenIdaman, userId) {
    return axios.post(`${baseurl}api/auth/login/idaman`, {
      tokenIdaman,
      userId,
    });
  }

  getJwt(param) {
    return axios.post(baseurl + 'api/auth/login', param);
  }

  getMsRegional() {
    return axios.get(baseurl + 'api/master/mst_regional', {
      headers: { Authorization: token },
    });
  }

  getMsLokasi(id) {
    return axios.get(baseurl + 'api/master/mst_lokasi/' + id, {
      headers: { Authorization: token },
    });
  }

  getMsUnit() {
    return axios.get(baseurl + 'api/master/mst_unitbisnis', {
      headers: { Authorization: token },
    });
  }

  getMsTahun() {
    return axios.get(baseurl + 'api/master/tahun_lkp', {
      headers: { Authorization: token },
    });
  }

  getMsHipo() {
    return axios.get(baseurl + 'api/master/hipo', {
      headers: { Authorization: token },
    });
  }

  getMsTipePekerjaan() {
    return axios.get(baseurl + 'api/master/tipeperkerjaan', {
      headers: { Authorization: token },
    });
  }

  getMsPelaksanaInvestigasi() {
    return axios.get(baseurl + 'api/master/pelaksanainvestigasi', {
      headers: { Authorization: token },
    });
  }

  getMsClsrCategory() {
    return axios.get(baseurl + 'api/master/clsrcategory', {
      headers: { Authorization: token },
    });
  }

  getMsPseLevel() {
    return axios.get(baseurl + 'api/master/pselevel', {
      headers: { Authorization: token },
    });
  }

  getMsKlasifikasiKecelakaan() {
    return axios.get(baseurl + 'api/master/klasifikasikecelakaan', {
      headers: { Authorization: token },
    });
  }

  getMsTipeInsiden() {
    return axios.get(baseurl + `api/master/tipe_insident`, {
      headers: { Authorization: token },
    });
  }

  postUploadDocument(tipe, data, setProgress) {
    return axios.post(baseurl + `api/incimanlkp/uploaddocument/${tipe}`, data, {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        console.log('progressEvent UPload', progressEvent);

        const { loaded, total } = progressEvent;
        const percentage = Math.floor(((loaded / 1000) * 100) / (total / 1000));
        setProgress?.(percentage);
      },
      // onDownloadProgress: (progressEvent) => {
      //   console.log("progressEvent DOwnload", progressEvent);
      //   const progress = 50 + (progressEvent.loaded / progressEvent.total) * 50;
      //   console.log(progress);
      //   setProgress(progress);
      // },
    });
  }

  postCartbyKategoryInsiden(data) {
    return axios.post(baseurl + 'api/incimanlkp/cartby_kategoryinsiden', data, {
      headers: { Authorization: token },
    });
  }

  postCartbyTipeInsiden(data) {
    return axios.post(baseurl + 'api/incimanlkp/cartby_tipeinsident', data, {
      headers: { Authorization: token },
    });
  }

  postCartbyStatusLkp(data) {
    return axios.post(baseurl + 'api/incimanlkp/cartby_statuslkp', data, {
      headers: { Authorization: token },
    });
  }

  getTaskList(data) {
    return axios.post(baseurl + 'api/incimanlkp/tasklist_summary', data, {
      headers: { Authorization: token },
    });
  }

  postTaskListSummaryVerifikator(data) {
    return axios.post(
      baseurl + 'api/incimanlkp/tasklist_summary_verifikator',
      data,
      {
        headers: { Authorization: token },
      }
    );
  }

  postMyLkpTaskListSummaryVerifikator(data) {
    return axios.post(
      baseurl + 'api/incimanlkp/mylkp_tasklist_verifikator',
      data,
      {
        headers: { Authorization: token },
      }
    );
  }

  postMyLapInvestTaskListSummaryVerifikator(data) {
    return axios.post(baseurl + 'api/incimanlkp/mylapinvest_tasklist', data, {
      headers: { Authorization: token },
    });
  }

  getTingkatKeparahanByValue(data) {
    return axios.get(
      baseurl +
        `api/incimanlkp/tingkat_keparahan_byvalue/${data.IdMstDetailEstimateImpact}/${data.ContectValue}`,
      {
        headers: { Authorization: token },
      }
    );
  }

  getEstimateImpactContent(IdMstDetailEstimateImpact) {
    return axios.get(
      baseurl +
        `api/incimanlkp/estimateimpact_content/${IdMstDetailEstimateImpact}`,
      {
        headers: { Authorization: token },
      }
    );
  }

  getEstimateImpactContentItem(IdEstimateImpactContent) {
    return axios.get(
      baseurl +
        `api/incimanlkp/estimateimpact_contentitem/${IdEstimateImpactContent}`,
      {
        headers: { Authorization: token },
      }
    );
  }

  getIncimanLkp(idlkp) {
    return axios.get(baseurl + `api/incimanlkp/${idlkp}`, {
      headers: { Authorization: token },
    });
  }

  putIncimanLkp(idlkp, data) {
    return axios.put(baseurl + `api/incimanlkp/${idlkp}`, data, {
      headers: { Authorization: token },
    });
  }

  deleteIncimanLkp(idlkp) {
    return axios.delete(baseurl + `api/incimanlkp/${idlkp}`, {
      headers: { Authorization: token },
    });
  }

  postIncimanLkp(data) {
    return axios.post(baseurl + `api/incimanlkp`, data, {
      headers: { Authorization: token },
    });
  }

  getLkpDecision(ParamLkpEncode) {
    return axios.get(
      baseurl + `api/incimanlkp/getlkpsummary/${ParamLkpEncode}`,
      {
        headers: { Authorization: token },
      }
    );
  }

  postLkpDecision(data) {
    return axios.post(baseurl + `api/incimanlkp/lkpdecision`, data, {
      headers: { Authorization: token },
    });
  }

  getLapInvestigasi(paramInvestigasiEncode) {
    return axios.get(
      baseurl + `api/incimanlapinvest/${paramInvestigasiEncode}`,
      {
        headers: { Authorization: token },
      }
    );
  }

  postLapInvestigasi(data) {
    return axios.post(baseurl + `api/incimanlapinvest`, data, {
      headers: { Authorization: token },
    });
  }

  // LFE
  putLapInvestigasi(id, data) {
    return axios.put(`${baseurl}api/incimanlapinvest/${id}`, data, {
      headers: { Authorization: token },
    });
  }

  postUploadLfe(data, setProgress) {
    return axios.post(baseurl + 'api/incimanlkp/uploaddocument/LFE', data, {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        console.log('progressEvent UPload', progressEvent);

        const { loaded, total } = progressEvent;
        const percentage = Math.floor(((loaded / 1000) * 100) / (total / 1000));
        setProgress(percentage);
      },
      // onDownloadProgress: (progressEvent) => {
      //   console.log("progressEvent DOwnload", progressEvent);
      //   const progress = 50 + (progressEvent.loaded / progressEvent.total) * 50;
      //   console.log(progress);
      //   setProgress(progress);
      // },
    });
  }

  postIncimanLfe(data) {
    return axios.post(baseurl + `api/incimanlkp/lfe/`, data, {
      headers: { Authorization: token },
    });
  }

  getIncimanLfe(LfeId) {
    return axios.get(baseurl + `api/incimanlkp/lfe/${LfeId}`, {
      headers: { Authorization: token },
    });
  }

  // IA
  postUploadIa(data, setProgress) {
    return axios.post(baseurl + 'api/incimanlkp/uploaddocument/IA', data, {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        console.log('progressEvent UPload', progressEvent);

        const { loaded, total } = progressEvent;
        const percentage = Math.floor(((loaded / 1000) * 100) / (total / 1000));
        setProgress(percentage);
      },
      // onDownloadProgress: (progressEvent) => {
      //   console.log("progressEvent DOwnload", progressEvent);
      //   const progress = 50 + (progressEvent.loaded / progressEvent.total) * 50;
      //   console.log(progress);
      //   setProgress(progress);
      // },
    });
  }

  postIncimanIa(data) {
    return axios.post(baseurl + `api/incimanlkp/incidentalert`, data, {
      headers: { Authorization: token },
    });
  }

  getIncimanIa(IaId) {
    return axios.get(baseurl + `api/incimanlkp/incidentalert/${IaId}`, {
      headers: { Authorization: token },
    });
  }

  getMsTimInvestigasi(data) {
    return axios.get(`${baseurl}api/idaman/users/${data.namaUser}`, {
      headers: { Authorization: token },
    });
  }

  // Assign PIC Laporan Invest
  getMsLapInvest(namauser) {
    return axios.get(`${baseurl}api/idaman/users/${namauser}`, {
      headers: { Authorization: token },
    });
  }

  postLapInvest(data) {
    return axios.post(`${baseurl}api/incimanlkp/assignpiclapinvest`, data, {
      headers: { Authorization: token },
    });
  }

  postIncimanLkpDashboard(data) {
    return axios.post(`${baseurl}api/incimanlkp/dashboard`, data);
  }

  postIncimanLkpFleetDashboard(data) {
    return axios.post(`${baseurl}api/incimanlkp/fleetdashboard`, data);
  }

  getMsIncidentCategory() {
    return axios(`${baseurl}api/master/incident_category`);
  }

  getListUserAdmin(search) {
    return axios.get(`${baseurl}api/idaman/users/${search}`, {
      headers: { Authorization: token },
    });
  }

  getListRoles() {
    return axios.get(`${baseurl}api/master/masterroles`, {
      headers: { Authorization: token },
    });
  }

  postUpdateUserAdmin(data) {
    return axios.post(`${baseurl}api/master/addupdateuseradmin`, data, {
      headers: { Authorization: token },
    });
  }

  getAdminUsers(data) {
    return axios.post(`${baseurl}api/master/useradmin`, data, {
      headers: { Authorization: token },
    });
  }

  getUserPermissions(payload) {
    return axios.post(`${baseurl}api/master/userpermission`, payload, {
      headers: { Authorization: token },
    });
  }

  getListPermissions() {
    return axios.get(`${baseurl}api/master/mstpermission`, {
      headers: { Authorization: token },
    });
  }

  getIdamanUsers(namaUser) {
    return axios.get(`${baseurl}api/idaman/users/${namaUser}`);
  }

  validateLkp(data) {
    return axios.post(`${baseurl}api/incimanlkp/getlistreviewer`, data);
  }

  postUpdateUserPermission(payload) {
    return axios.post(`${baseurl}api/master/addupdateuserpermission`, payload, {
      headers: { Authorization: token },
    });
  }

  getUserRegions(payload) {
    return axios.post(`${baseurl}api/master/mst_regionalindex`, payload, {
      headers: { Authorization: token },
    });
  }

  addUserRegions(payload) {
    return axios.post(`${baseurl}api/master/add_regional`, payload, {
      headers: { Authorization: token },
    });
  }

  updateUserRegions(id, payload) {
    return axios.post(`${baseurl}api/master/update_regional/${id}`, payload, {
      headers: { Authorization: token },
    });
  }

  getApplicationConfig(payload) {
    return axios.post(`${baseurl}api/master/appconfig`, payload, {
      headers: { Authorization: token },
    });
  }

  updateApplicationConfig(id, payload) {
    return axios.post(`${baseurl}api/master/updateappconfig/${id}`, payload, {
      headers: { Authorization: token },
    });
  }

  deleteOrRejectIncimanlkp(id, payload) {
    return axios.put(`${baseurl}api/incimanlkp/deleteorreject/${id}`, payload, {
      headers: { Authorization: token },
    });
  }

  getActionTrackingTaskList(payload) {
    return axios.post(`${baseurl}api/actiontracking/tasklist`, payload, {
      headers: { Authorization: token },
    });
  }

  getActionTrackingTaskListCreator(payload) {
    return axios.post(`${baseurl}api/actiontracking/tasklistcreator`, payload, {
      headers: { Authorization: token },
    });
  }

  getKegiatanActionTracking() {
    return axios.get(`${baseurl}api/master/kegiatanactiontracking`, {
      headers: { Authorization: token },
    });
  }

  getTahunActionTracking() {
    return axios.get(`${baseurl}api/master/tahun_actionTracking`, {
      headers: { Authorization: token },
    });
  }

  getStatusHeaderActionTracking() {
    return axios.get(`${baseurl}api/master/statusheader`, {
      headers: { Authorization: token },
    });
  }

  getListLapInvestigasi(payload) {
    return axios.post(`${baseurl}api/actiontracking/listlapinvest`, payload, {
      headers: { Authorization: token },
    });
  }

  getRekomendasiInvestigasi(idInvestigasi) {
    return axios.get(
      `${baseurl}api/actiontracking/lapinvestrekomendasi/${idInvestigasi}`,
      {
        headers: { Authorization: token },
      }
    );
  }
  createActionTracking(payload) {
    return axios.post(`${baseurl}api/actiontracking`, payload, {
      headers: { Authorization: token },
    });
  }
  updateActionTracking(payload) {
    return axios.put(`${baseurl}api/actiontracking/${payload.id}`, payload, {
      headers: { Authorization: token },
    });
  }
  getActionTrackingById(encodeId) {
    return axios.get(`${baseurl}api/actiontracking/${encodeId}`, {
      headers: { Authorization: token },
    });
  }
  getChartByStatus(payload) {
    return axios.post(`${baseurl}api/actiontracking/cartbystatus`, payload, {
      headers: { Authorization: token },
    });
  }
  getChartByPriority(payload) {
    return axios.post(`${baseurl}api/actiontracking/cartbypriority`, payload, {
      headers: { Authorization: token },
    });
  }

  updateDetailActionTracking(payload) {
    return axios.post(
      `${baseurl}api/actiontracking/updatestatusdetail`,
      payload,
      {
        headers: { Authorization: token },
      }
    );
  }

  exportExcelActionTracking(payload) {
    return axios.post(`${baseurl}api/actiontracking/exportexcel`, payload, {
      headers: { Authorization: token },
    });
  }

  reAssignCreator(payload) {
    return axios.post(`${baseurl}api/actiontracking/reassigncreator`, payload, {
      headers: { Authorization: token },
    });
  }

  getMatrixDueDate(payload) {
    return axios.post(
      `${baseurl}api/actiontracking/getmatrixduedate`,
      payload,
      {
        headers: { Authorization: token },
      }
    );
  }
  checkDueDate(payload) {
    return axios.post(`${baseurl}api/actiontracking/checkduedate`, payload, {
      headers: { Authorization: token },
    });
  }
  getListLkpSummary(payload) {
    return axios.post(`${baseurl}api/incimanlkp/listlkp_summary`, payload, {
      headers: { Authorization: token },
    });
  }
  getFungsiActionTracking() {
    return axios.get(`${baseurl}api/master/fungsiactiontracking`, {
      headers: { Authorization: token },
    });
  }

  bulkInsert(tipe, data, setProgress) {
    return axios.post(baseurl + `api/actiontracking/bulkinsert`, data, {
      headers: {
        Authorization: token,
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        console.log('progressEvent UPload', progressEvent);

        const { loaded, total } = progressEvent;
        const percentage = Math.floor(((loaded / 1000) * 100) / (total / 1000));
        setProgress?.(percentage);
      },
    });
  }

  deleteDraft(payload) {
    return axios.post(`${baseurl}api/actiontracking/deletedraft`, payload, {
      headers: { Authorization: token },
    });
  }

  setButtonState(buttonElement, text, disabled) {
    buttonElement.innerText = text;
    buttonElement.disabled = disabled;
  }

  async viewFile(url, event) {
    // Prevent default event behavior
    event.preventDefault();

    // Reference to the current element
    const currentElement = event.currentTarget;
    const originalText = currentElement.innerText;
    this.setButtonState(currentElement, 'Loading...', true);

    try {
      const response = await axios.get(url, {
        headers: { Authorization: token },
        responseType: 'blob',
      });

      if (!response.data || response.data.type !== 'application/pdf') {
        throw new Error('Invalid file type or empty response');
      }

      const fileURL = URL.createObjectURL(
        new Blob([response.data], { type: 'application/pdf' })
      );
      window.open(fileURL, '_blank', 'noopener,noreferrer');
    } catch (e) {
      console.error('Error in viewFile:', e);
      alert('Failed to load the file'); // Provide user feedback on failure
    } finally {
      // Restore the button state regardless of success or failure
      this.setButtonState(currentElement, originalText, false);
    }
  }
}

export default new ApiService();
